module.exports = __webpack_public_path__ + "img/online_szamla.15fac965.jpg";